import React, { useContext, useEffect, useState } from "react";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import esriRequest from "@arcgis/core/request";

import { makeStyles } from "@material-ui/core/styles";
import { MapContext } from "contexts/MapContext";
import { UserContext } from "contexts/UserContext";
import Chip from "components/Chip";

import HikingWalkingIcon from "assets/icons/trailcard/DeTour ICO Sets_Trailhead.png";
import HuntingFishingIcon from "assets/icons/trailcard/DeTour ICO Sets_Hunting.png";
import MultiUseIcon from "assets/icons/trailcard/DeTour ICO Sets_Multi-Use.png";
import DogIcon from "assets/icons/trailcard/DeTour ICO Sets_Pet.png";
import HorseIcon from "assets/icons/trailcard/Detour Icon Sets_Horse.png";
import AccessibleIcon from "assets/icons/trailcard/DeTour ICO Sets_Accessible.png";
import AtvIcon from "assets/icons/trailcard/Detour Icon Sets-56.png";
import BicycleIcon from "assets/icons/trailcard/MountainBiking.png";
import SkiingIcon from "assets/icons/trailcard/Detour Icon Sets_Cross country.png";
import SnowmobilesIcon from "assets/icons/trailcard/Detour Icon Sets_Snow mobile.png";

import NoImage from "assets/icons/trailcard/NoImage.svg";

import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@material-ui/core";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";

const useStyles = makeStyles({
  root: {
    borderRadius: "20px",
    margin: "1vh 1vw",
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.2)",
  },
  media: {
    height: 150,
    backgroundSize: "cover",
    backgroundBlendMode: "screen",
    filter: "brightness(70%)",
  },
  overlayTrail: {
    color: "white",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0.25px",
    overflow: "hidden",
    whiteSpace: "break-spaces",
  },
  overlayManageArea: {
    color: "white",
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  infoFlex: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "85px",
    left: "10px",
  },
  flexBox: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
  },
  distance: {
    fontWeight: "600",
    lineHeight: "20px",
    fontSize: "14px",
    letterSpacing: "0.25px",
    /* identical to box height, or 143% */
  },
  trailConfiguration: {
    fontWeight: "300",
    lineHeight: "20px",
    fontSize: "14px",
    letterSpacing: "0.25px",
  },
  difficulty: {
    fontFamily: "Open Sans",
    background: "#D1E9CB",
    borderRadius: "16px",
    width: "54px",
    height: "24px",
    textAlign: "center",
    marginLeft: "15px",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#222222",
  },
  fee: {
    fontWeight: "600",
    marginLeft: "auto",
    marginRight: "10px",
  },
  iconFlex: {
    display: "flex",
    flexDirection: "row",
    marginTop: "8px",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    gap: "5px",
  },
  huntingFishingIcon: {
    backgroundImage: `url(${HuntingFishingIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  hikingWalkingIcon: {
    backgroundImage: `url(${HikingWalkingIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  multiUseIcon: {
    backgroundImage: `url(${MultiUseIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  bicycleIcon: {
    backgroundImage: `url(${BicycleIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  dogIcon: {
    backgroundImage: `url(${DogIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  accessibleIcon: {
    backgroundImage: `url(${AccessibleIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  horseIcon: {
    backgroundImage: `url(${HorseIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  snowmobilesIcon: {
    backgroundImage: `url(${SnowmobilesIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  atvIcon: {
    backgroundImage: `url(${AtvIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  skiingIcon: {
    backgroundImage: `url(${SkiingIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  favIcon: {
    zIndex: "2",
    backgroundSize: "contain",
    color: "white",
    height: "18.5px",
    width: "20px",
    top: "13px",
    left: "13px",
    position: "absolute",
  },
  imgFlex: {
    display: "flex",
  },
  trailType: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19.2px",
    letterSpacing: "0.25px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    justifySelf: "flex-start",
    flexGrow: "1",
    display: "inline-flex",
  },
  difficultyChip: {
    justifySelf: "flex-end",
  },
  managerFlex: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    marginTop: "8px",
  },
  managerAttr: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.25px",
    marginTop: "4px",
  },
  managerTitle: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.25px",
  },
  distanceSurfaceFlex: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    marginTop: "8px",
    justifyContent: "space-between",
  },
});

const favIconStyle = {
  backgroundSize: "contain",
  color: "white",
  height: "24.5px",
  width: "28px",
  top: "13px",
  left: "13px",
  position: "absolute",
};

export default function TrailCard({
  attributes,
  difficulty,
  icons,
  setFavoritedTrails,
  favoritedTrails,
  favorited,
  loggedIn,
  favoriteCard,
}) {
  const classes = useStyles();
  const { userInfo } = useContext(UserContext);
  const [favorite, setFavorite] = useState(favorited);
  const {
    mapView,
    setSidebarSelection,
    setCardHistory,
    extentHistory,
    setExtentHistory,
  } = useContext(MapContext);

  useEffect(() => {
    (async () => {
      if (userInfo) {
        if (favorite === true && userInfo && userInfo.favoritesUrl) {
          const res = await esriRequest(userInfo.favoritesUrl + "/query", {
            method: "post",
            query: {
              where: `TrailID = ${attributes.PRIMARY_TRAIL_ID} AND IsFeaturedTrail= 0`,
              f: "json", // format,
              token: userInfo.credential.token,
            },
          });
          if (!res.data.features.length) {
            esriRequest(userInfo.favoritesUrl + "/applyEdits", {
              method: "post", // POST request
              query: {
                adds: JSON.stringify([
                  {
                    attributes: {
                      TrailID: attributes.PRIMARY_TRAIL_ID,
                      IsFeaturedTrail: 0,
                    },
                  },
                ]),
                f: "json", // format
              },
            })
              .then((r) => {
                setFavoritedTrails([
                  ...favoritedTrails,
                  attributes.PRIMARY_TRAIL_ID,
                ]);
              })
              .catch(function (e) {
                console.log(e);
              });
          }
        } else if (favorite === false) {
          const layer = new FeatureLayer({
            url: userInfo.favoritesUrl,
          });
          let query = layer.createQuery();
          query.where = `TrailID = '${attributes.PRIMARY_TRAIL_ID}'`;
          query.outFields = ["OBJECTID"];
          layer.queryFeatures(query).then((r) => {
            const objectIds = r.features.map(
              (feature) => feature.attributes.OBJECTID
            );
            esriRequest(userInfo.favoritesUrl + "/applyEdits", {
              method: "post", // POST request
              query: {
                deletes: JSON.stringify(objectIds),
                f: "json", // format
              },
            })
              .then((r) => {
                console.log(r);
                if (favoriteCard) {
                  setFavoritedTrails(
                    favoritedTrails.filter((trail) => {
                      if (trail && trail.attributes) {
                        return (
                          trail.attributes.PRIMARY_TRAIL_ID !==
                          attributes.PRIMARY_TRAIL_ID
                        );
                      }
                      return false;
                    })
                  );
                } else {
                  setFavoritedTrails(
                    favoritedTrails.filter(
                      (trail) => trail !== attributes.PRIMARY_TRAIL_ID
                    )
                  );
                }
              })
              .catch(function (e) {
                console.log(e);
              });
          });
        }
      }
    })();
    //update user's favorite trails/routes
  }, [favorite]);

  const handleOnClick = async () => {
    const {
      filterMapDataForTrailSelected,
      getAllTrailFeaturesByTrailId,
      getAllNearbyTrails,
    } = await import("data/map");

    const trailId = attributes.PRIMARY_TRAIL_ID;
    const features = await getAllTrailFeaturesByTrailId(
      trailId,
      mapView.spatialReference
    );
    const trailGeometry =
      features[0].geometry?.paths?.length > 10
        ? features[0].geometry.extent
        : features[0].geometry;

    const nearbyFeatures = await getAllNearbyTrails(trailGeometry, trailId);
    setSidebarSelection(["Trail", attributes, nearbyFeatures, features[0]]);
    await filterMapDataForTrailSelected(features);

    // TODO: save current extent to extentHistory in mapContext
    if (!extentHistory) {
      setExtentHistory(mapView.extent);
    }
    setCardHistory();
    mapView.when(function () {
      mapView.goTo({
        target: features[0],
        // zoom: 11,
      });
    });
  };

  const surfaceTranslate = (surfaceType) => {
    if (surfaceType === "Aggregt") return "Gravel";
    if (surfaceType === "Boardwlk") return "Boardwalk";
    return surfaceType;
  };

  const primaryTypes = {
    HikeWalk: "Hiking/Walking Trail",
    MultiUse: "Multi-use",
    Motorized: "Motorized Trail",
    MntnBike: "Mountain Biking Trail",
    Snowmobile: "Snowmobiling Trail",
    Equestrian: "Equestrian Trail",
    XCountrySki: "Cross-country Ski Trail",
    HuntFishAccess: "Hunting/Fishing Access Trail",
  };

  const primaryTypeIcon = {
    HikeWalk: "hikingWalkingIcon",
    MultiUse: "multiUseIcon",
    Motorized: "atvIcon",
    MntnBike: "bicycleIcon",
    Snowmobile: "snowmobilesIcon",
    Equestrian: "horseIcon",
    XCountrySki: "skiingIcon",
    HuntFishAccess: "huntingFishingIcon",
  };

  const configuration = {
    Loop: "Loop",
    OutBack: "Out and Back",
    Linear: "Linear",
    NA: "Not assessed",
    "Not assessed": "NA",
  };

  const banner = {
    required:
      attributes.STATUS.toLowerCase() === "closed" ||
      attributes.STATUS.toLowerCase() === "partclosed",
    text:
      attributes.STATUS.toLowerCase() === "closed"
        ? "CLOSED"
        : "Partially Closed",
    color: attributes.STATUS.toLowerCase() === "closed" ? "#B52626" : "#BF5609",
  };

  return (
    <Card className={classes.root} onClick={handleOnClick}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={
            attributes.Attachment_URL ? attributes.Attachment_URL : NoImage
          }
          title="Trail Card"
        />
        <div class={classes.imgFlex}>
          {loggedIn ? (
            favorited ? (
              <FavoriteIcon
                style={favIconStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  setFavorite(false);
                }}
              />
            ) : (
              <FavoriteBorderIcon
                style={favIconStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  setFavorite(true);
                }}
              />
            )
          ) : null}
        </div>
        <div class={classes.infoFlex}>
          <div class={classes.overlayTrail}>{attributes.PRIMARY_NAME}</div>
          <div class={classes.overlayManageArea}>
            {attributes?.MANAGED_AREA_NAME &&
            attributes?.MANAGED_AREA_NAME !== "<Null>"
              ? attributes?.MANAGED_AREA_NAME
              : ""}
          </div>
        </div>

        {/* Status: Closed/ Partially Closed  */}
        {banner.required && (
          <CardContent
            style={{
              background: banner.color,
              padding: "5px",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              align="center"
              style={{ color: "whitesmoke", fontSize: "14px" }}
            >
              {banner.text}
            </Typography>
          </CardContent>
        )}

        {/* Main Content */}
        <CardContent>
          <div class={classes.flexBox}>
            <div class={classes.trailType}>
              <span>{primaryTypes[attributes.PRIMARY_TYPE]}</span>
              <div
                class={classes[primaryTypeIcon[attributes.PRIMARY_TYPE]]}
                style={{ marginLeft: "8px" }}
              ></div>
            </div>
            <Chip
              class={classes.difficultyChip}
              type="Difficulty"
              trailDifficulty={difficulty ? difficulty : "Not Assessed"}
            ></Chip>
          </div>
          <div class={classes.managerFlex}>
            <div class={classes.managerTitle}>Manager</div>
            <div class={classes.managerAttr}>{attributes.MANAGER}</div>
          </div>
          <div class={classes.distanceSurfaceFlex}>
            <div class={classes.managerFlex}>
              <div class={classes.managerTitle}>Length</div>
              <div class={classes.managerAttr}>
                <span class={classes.distance}>
                  {Math.round(10 * (attributes.Length_SPC / 5280)) / 10 > 0.1
                    ? Math.round(10 * (attributes.Length_SPC / 5280)) / 10
                    : "< 0.1"}{" "}
                  mi
                </span>
                {attributes.CONFIGURATION ? (
                  <span> ({configuration[attributes.CONFIGURATION]})</span>
                ) : null}
              </div>
            </div>
            <div class={classes.managerFlex}>
              <div class={classes.managerTitle}>Surface</div>
              <div class={classes.managerAttr}>
                <span class={classes.distance}>
                  {surfaceTranslate(attributes.SURFACE)}
                </span>
              </div>
            </div>
          </div>
          {icons["DOGS"] || icons["WHEELCHAIR_FRIENDLY"] ? (
            <div class={classes.iconFlex}>
              {icons["DOGS"] ? <div class={classes.dogIcon}></div> : null}
              {/* {icons['HORSES'] ? <div class={classes.horseIcon}></div> : null} */}
              {icons["WHEELCHAIR_FRIENDLY"] ? (
                <div class={classes.accessibleIcon}></div>
              ) : null}
              {/* {icons['BIKES'] ? <div class={classes.bicycleIcon}></div> : null} */}
              {/* {icons['SNOWMOBILES'] ? <div class={classes.snowmobilesIcon}></div> : null}
              {icons['OFF_ROAD_4X4'] ? <div class={classes.atvIcon}></div> : null}
              {icons['XC_SKIING'] ? <div class={classes.skiingIcon}></div> : null} */}
            </div>
          ) : null}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
